import React, { useEffect, useRef, useState } from "react";
import MathJax from "react-mathjax2";
import { EditableMathField } from "react-mathquill";
import TYPE from "../../../constant/TYPE";
import useLaTexCode from "../../../hooks/useLaTexCode";

const Viewer = ( props ) => {

  const [ question, setQuestion ] = useState( [] );
  const [ answer, setAnswer ] = useState( [] );
  const [ answerIndex, setAnswerIndex ] = useState( 0 );

  const mathField = useRef();

  const { getEndScope } = useLaTexCode();

  useEffect( () => {
    let answer = [];
    const mapExercise = ( value, index, origin ) => {
      const cssId = `${ TYPE.ID.ANSWER_AREA }${ index }}{`;
      if ( index ) {
        const startValue = value.slice( value.indexOf( '{' ) );
        const endPoint = getEndScope( startValue );
        answer = [ ...answer, `\\phantom{${ startValue.slice( 1, endPoint - 1 ) }}` ];
        return `${ startValue.slice( endPoint - 1 ) }${ origin.length === index + 1 ? '' : cssId }`;
      } else {
        return `${ value }${ cssId }`;
      }
    };
    setQuestion( props.question.split( 'inputArea' ).map( mapExercise ) );
    setAnswer( answer );
  }, [ props.question ] );

  useEffect( () => {
    if ( props.answer ) {
      const changedAnswer = props.answer.split( '?' );
      switch ( changedAnswer[ 0 ] ) {
        case '<' :
          mathField.current.latex( '' );
          setAnswerIndex( 0 < answerIndex ? answerIndex - 1 : answer.length - 1 );
          break;
        case '>' :
          mathField.current.latex( '' );
          setAnswerIndex( answer.length - 1 > answerIndex ? answerIndex + 1 : 0 );
          break;
        default :
          if ( 'overwrite' === changedAnswer[ 1 ] ) {
            mathField.current.latex( changedAnswer[ 0 ] );
          } else {
            mathField.current.write( changedAnswer[ 0 ] );
          }
          setAnswer( answer.map( ( v, i ) => i === answerIndex ? mathField.current.latex() : v ) );
      }
    }
  }, [ props.answer ] );

  useEffect( () => {
    mathField.current.latex( '' );
  }, [ props.keypadType ] );

  const mountEditableMathField = ( bare ) => {
    mathField.current = bare;
  };

  return (
    <div style={ { float : 'left', width : '40%' } }>
      <EditableMathField style={ { display : 'none' } } latex="" mathquillDidMount={ mountEditableMathField } />
      <MathJax.Node>{ question.map( ( v, i, o ) => i + 1 === o.length ? v : `${ v }${ answer[ i ] }` ).join( '' ) }</MathJax.Node>
    </div>
  );

};

export default Viewer;
